export enum BookingStatus {
    Active = 'Active',
    UserCanceled = 'Canceled',
    AdminCanceled = 'Invalidated'
}
